module.exports = __webpack_public_path__ + "img/back2.fd1b56b1.jpg";